import { Banner, BannerItem } from '@athena/forge';
import { getLocalizedString } from '../../utils/i18n-utils';
import { getPasswordResetUrlByClientId } from '../../utils/app-utils';
import AmplitudeUtils from '../../utils/amplitude-utils';
import Link from '../common/Link';

export default function InvalidUsernameOrPasswordBanner() {
  const clientId = settings.clientId;
  const HEADER_TEXT = getLocalizedString('errors.E0000004');
  const NON_LINK_HEADER_DESCRIPTION = getLocalizedString('invalid.username.password.description');
  const RESET_PASSWORD_LINK_TEXT = getLocalizedString('invalid.username.password.link.text');
  const DOT = '.';

  const handleResetPasswordClick = async () => {
    await AmplitudeUtils.logCustomEvent('InvalidCredentials_ResetPasswordLinkClick', {});

    // Find and trigger click on athena forgot password button
    const $forgotPasswordButton = jQueryCourage('#athena-forgot-password-link button');

    if ($forgotPasswordButton.length > 0) {
      $forgotPasswordButton.trigger('click');
      return;
    }

    // Fallback when the forgot password button element is not found. The legacy
    // athenaNet resetpassword.esp page has been retired (UIAMUA-8419), so route to
    // the OHSW-hosted reset page instead.
    const passwordResetUrl = getPasswordResetUrlByClientId(clientId);
    if (passwordResetUrl) {
      window.location.assign(passwordResetUrl);
    }
    else {
      await AmplitudeUtils.logCustomEvent('InvalidCredentials_ResetPasswordLinkUnavailable', { clientId });
    }
  };

  return (
    <Banner alertType='critical' className='fe_u_padding--small'>
      <BannerItem headerText={HEADER_TEXT}>
        {NON_LINK_HEADER_DESCRIPTION}
        <Link text={RESET_PASSWORD_LINK_TEXT} href="#" onClick={handleResetPasswordClick} />
        {DOT}
      </BannerItem>
    </Banner>
  );
}
